import { type FC, useEffect, useState } from 'react'
import { RemoteUser, type IAgoraRTCRemoteUser } from 'agora-rtc-react'
import { PATIENT_VOLUME_DEFAULT } from '../constants'
import styles from './styles/AgoraVideoContainer.module.css'
import { VideoCallIcon } from './videoCallIcons'

const VIDEO_OFF_OVERLAY_DELAY_MS = 1500

type RemoteUserCardProps = {
  user: IAgoraRTCRemoteUser
  patientVolume: number
}

export const RemoteUserCard: FC<RemoteUserCardProps> = ({ user, patientVolume }) => {
  const hasVideo = user.hasVideo
  const hasAudio = user.hasAudio
  const audioTrack = user.audioTrack

  const [showMutedOverlay, setShowMutedOverlay] = useState(!hasVideo)

  useEffect(() => {
    if (hasVideo) {
      setShowMutedOverlay(false)
    } else {
      const timer = setTimeout(() => {
        setShowMutedOverlay(true)
      }, VIDEO_OFF_OVERLAY_DELAY_MS)
      return () => clearTimeout(timer)
    }
  }, [hasVideo])

  useEffect(() => {
    if (!audioTrack) return

    if (patientVolume > PATIENT_VOLUME_DEFAULT) {
      audioTrack.setAmplifiedVolume(patientVolume)
    } else {
      audioTrack.setVolume(patientVolume)
    }
  }, [audioTrack, patientVolume])

  return (
    <div className='position-relative w-100 h-100'>
      <RemoteUser user={user} playVideo={true} playAudio={true} className={styles.remoteUser} />

      {showMutedOverlay && (
        <div
          className={`position-absolute top-0 bottom-0 start-0 end-0 z-index-2 d-flex align-items-center justify-content-center pe-none ${styles.mutedOverlay}`}
        >
          <i className={`${VideoCallIcon.VideoOff} ${styles.mutedOverlayIcon}`} />
        </div>
      )}

      {!hasAudio && (
        <div
          className={`position-absolute z-index-3 d-flex align-items-center text-white ${styles.audioMutedBadge}`}
        >
          <i className={VideoCallIcon.MicOff} />
        </div>
      )}
    </div>
  )
}
